<template>
  <div class="countdown-clock">
    <span class="countdown-clock__segment">
      <span class="countdown-clock__hours">{{ hours }}</span>
      <span class="countdown-clock__label">Hours</span>
    </span>
    :
    <span class="countdown-clock__segment">
      <span class="countdown-clock__minutes">{{ minutes }}</span>
      <span class="countdown-clock__label">Minutes</span>
    </span>
    :
    <span class="countdown-clock__segment">
      <span class="countdown-clock__seconds">{{ seconds }}</span>
      <span class="countdown-clock__label">Seconds</span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'CountDown',
  props: {
    // Optional timestamp to start from (ISO 8601 string)
    startTimestamp: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      hours: '23',
      minutes: '59',
      seconds: '59',
      interval: null, // To store the interval ID for cleanup
    }
  },
  mounted() {
    // Start the countdown with either the provided timestamp or current time
    const startTime = this.startTimestamp
      ? new Date(this.startTimestamp)
      : new Date()
    this.startCountdown(startTime)
  },
  beforeUnmount() {
    // Clear the interval when the component is destroyed
    if (this.interval) clearInterval(this.interval)
  },
  methods: {
    startCountdown(startTime) {
      // Calculate the target time (24 hours after the start time)
      const targetTime = new Date(startTime.getTime() + 24 * 60 * 60 * 1000)

      const updateCountdown = () => {
        const now = new Date()
        const timeRemaining = targetTime - now

        if (timeRemaining <= 0) {
          clearInterval(this.interval)
          this.hours = '23'
          this.minutes = '59'
          this.seconds = '59'
          return
        }

        // Convert timeRemaining to hours, minutes, and seconds
        const hours = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24)
        const minutes = Math.floor((timeRemaining / (1000 * 60)) % 60)
        const seconds = Math.floor((timeRemaining / 1000) % 60)

        // Format the output with leading zeros
        const padded = (num) => num.toString().padStart(2, '0')

        this.hours = padded(hours)
        this.minutes = padded(minutes)
        this.seconds = padded(seconds)
      }

      // Initialize the countdown immediately
      updateCountdown()

      // Set up the interval to update every second
      this.interval = setInterval(updateCountdown, 1000)
    },
  },
}
</script>
